/**
 * Matching - form exports and hardcoded slug.
 * Registration is handled centrally in content-prompt/src/index.ts.
 */

export const MATCHING_SLUG = 'matching_text_pairs';

export { MatchingForm } from './MatchingForm';
export type { MatchingMediaType, MatchingSourceType, MatchingFormState } from './types';
export { MEDIA_OPTIONS, DEFAULT_FORM_STATE } from './types';
export { QUESTION_TYPE_PRESETS, QUICK_CREATE_TEMPLATES } from './config';
export type { QuickCreateTemplate } from './config';
